/**
 * Página inicial: o logo e as páginas usadas recentemente pela pessoa. A navegação
 * completa fica no menu do topo.
 */
import { Anchor, Center, Group, Image, SimpleGrid, Text } from '@mantine/core';
import { Link } from 'react-router';

import { useUsuario } from '../api/sessao';
import { rotaNova, type Pagina as PaginaApp } from '../app/paginas';
import { Pagina, Secao } from '../components/Layout';
import { useRecentes } from '../lib/recentes';

function LinkPagina({ p }: { p: PaginaApp }) {
  return (
    <Group gap={6} wrap="nowrap">
      <Anchor component={Link} to={rotaNova(p)} size="sm">
        {p.titulo}
      </Anchor>
      <Text size="xs" c="dimmed">
        {p.secao}
      </Text>
    </Group>
  );
}

export function Inicio() {
  const { data: usuario } = useUsuario();
  const recentes = useRecentes(usuario?.email);
  return (
    <Pagina>
      <Center pt="xl" pb="lg">
        <Image src="/logo_sidebar.png" alt="Persevera Asset Management" w={420} maw="80%" />
      </Center>
      {recentes.length > 0 ? (
        <Secao
          titulo="Usadas recentemente"
          legenda="As últimas páginas que você abriu neste navegador."
        >
          <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing={6}>
            {recentes.map((p) => (
              <LinkPagina key={p.slugLegado} p={p} />
            ))}
          </SimpleGrid>
        </Secao>
      ) : (
        <Text size="sm" c="dimmed" ta="center">
          Use o menu acima para abrir uma página. As que você usar aparecem aqui.
        </Text>
      )}
    </Pagina>
  );
}
